import Debug from 'debug';
import _ from 'lodash';
const debug = Debug(`knack.core.helpers.reports.processMultipleChoiceGroup`);
export const processMultipleChoiceGroup = (group, old_filters, field, report) => {
    debug(`report-helper.processMultipleChoiceGroup`);
    report.filter_groups.push([]);
    let column = 0;
    if (!field && !field.format && !field.format.options) {
        return;
    }
    return _.each(old_filters, function (filter) {
        field.format.options = _.sortBy(field.format.options, function (option) {
            return option;
        });
        if (group.sort === `desc`) {
            field.format.options = field.format.options.reverse();
        }
        _.each(field.format.options, function (option) {
            if (!option) {
                return;
            }
            const new_filter = _.cloneDeep(filter);
            new_filter.push({
                field: field.key,
                operator: `is`,
                value: option,
                header: option
            });
            report.filters.push(new_filter);
            if (column === 0) {
                report.filter_groups[report.filter_groups.length - 1].push({
                    header: option
                });
            }
        });
        column++;
    });
};
